import React, {Component} from "react";

class Impedance extends Component {

    render() {
        return (
            <div className="container-fluid">
                <p> ※ 国際配送便のため、到着予定日中の到着になります。
                </p>
                <p> ※ お届け予定は運送会社様の事情、交通事情、気象状況等により予定日にお届けできない場合がございます。
                </p>
                <p> ※ 到着日が土曜日、日曜日及び祝祭日の商品に関しましては、場合により到着予定日にお届けできない事がございます。
                </p>

            </div>
        );
    }
}

export default Impedance;


// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/Impedance.js